import React, { useState, useEffect, createContext, useContext } from 'react'
import Api from 'utils/api'
import Loader from 'component/loader'
import ConfirmDeleteModalHeader from 'component/confirm-delete'
import ConfirmationModal from 'component/confimation-modal'

const initPlanContextPropsState = {
  plans: [],
  setPlans: () => {},
  openModal: false,
  setOpenModal: () => {},
  selectedPlan: undefined,
  setSelectedPlan: () => {},
  showConfirmDelete: false,
  setShowConfirmDelete: () => {},
}

const PlanContext = createContext(initPlanContextPropsState)

const usePlan = () => {
  return useContext(PlanContext)
}

const PlanProvider = ({ children }) => {
  const [loader, setLoader] = useState(true)
  const [plans, setPlans] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [selectedPlan, setSelectedPlan] = useState()
  const [showConfirmDelete, setShowConfirmDelete] = useState(false)

  const getPlans = async () => {
    setLoader(true)
    const { response } = await Api(`/plans`, 'get')

    if (response) setPlans(response.data)
    setLoader(false)
  }
  const onLoad = () => {
    getPlans()
  }

  useEffect(onLoad, [])

  const closeDeleteModal = () => {
    setShowConfirmDelete(false)
    setSelectedPlan()
  }

  const deleteCampaign = async () => {
    const { response } = await Api('/plans?_id=' + selectedPlan._id, 'delete', {
      notify: true,
    })
    if (response) {
      const idx = plans.findIndex((item) => item._id == selectedPlan._id)
      plans.splice(idx, 1)
      setPlans([...plans])
      setShowConfirmDelete(false)
    }
    setSelectedPlan()
    return
  }

  return (
    <PlanContext.Provider
      value={{
        plans,
        setPlans,
        openModal,
        setOpenModal,
        selectedPlan,
        setSelectedPlan,
        showConfirmDelete,
        setShowConfirmDelete,
      }}
    >
      {loader ? <Loader /> : children}
      <ConfirmationModal
        open={showConfirmDelete}
        onClose={closeDeleteModal}
        onConfirm={deleteCampaign}
      >
        <ConfirmDeleteModalHeader onClose={closeDeleteModal} />
        <p className='p-4'>
          Are you sure you want to delete <b>{selectedPlan?.productname}</b>?
        </p>
      </ConfirmationModal>
    </PlanContext.Provider>
  )
}

export { PlanProvider, usePlan }
